module.exports = __webpack_public_path__ + "media/reskin-images/img--upcoming-cohorts-a56c0fc7.jpeg";